const formatUploadCreditCost = (
  value: number | null | undefined,
  emptyLabel: string,
) => {
  if (typeof value === 'number') {
    return `${value} credit(s)`
  }

  return emptyLabel
}

export { formatUploadCreditCost }
